/**
 * @generated SignedSource<<adee257b2a61192371d6a4e1f1f91b11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: "Article";
  readonly " $fragmentSpreads": FragmentRefs<"articleSeoArticle" | "contentShareWidgetContent" | "headerContentBookmarkArticle" | "headerContentCommentTrigger" | "helpersCheckIsStyleArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseNotificationReadStatusArticle" | "onboardingNewsletterSubscriptionArticle">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "cc5be513e68f1ecd03f9441a86aaf374";

export default node;
